import { useEffect, useState } from "react";

/**
 * Trailing-debounce a value: the returned value updates only after `delayMs`
 * of quiet. Used to coalesce slice-driven surface refetches against the
 * single-worker local API (FXC-9009 §7): N panels keying their queries on the
 * debounced slice spec means one pin-slider drag issues one batch of requests
 * when it settles, not a 60 Hz stampede.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = window.setTimeout(() => setDebounced(value), delayMs);
    return () => window.clearTimeout(id);
  }, [value, delayMs]);
  return debounced;
}
